import { useTranslation } from 'next-i18next';
import { BulbColorIcon, PlusSmallIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import { type BuildQuizListItem } from '@/views/build/form/schema/BuildQuizListSchema';
import { HintCard } from './HintCard';
export const HintEdit = ({
  isVisible,
  hint,
  onChange
}: {
  isVisible: boolean;
  hint: BuildQuizListItem['hint'];
  onChange: (value: BuildQuizListItem['hint']) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className={cn('hidden', isVisible && 'flex flex-col gap-sm')} data-sentry-component="HintEdit" data-sentry-source-file="HintEdit.tsx">
      {!hint && <Button onMouseDown={e => {
      e.preventDefault();
    }} onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      onChange({
        type: 'text',
        value: ''
      });
    }} className="w-fit" variant="outlined" intent="neutral" size="sm" rounded="full" leftSlot={<BulbColorIcon size="xs" />} rightSlot={<PlusSmallIcon size="xs" />}>
          {t('quizCreateItem.addHint.button')}
        </Button>}
      {hint && <HintCard hint={hint} onChange={onChange} />}
    </div>;
};